import { Account } from '@/domain/usecases'
import { ContentUnsubscribe } from '@/domain/usecases/content/content-unsubscribe'
import RegisteredPlanBaseLoader from '@/main/routes/loaders/registered-plan-base-loader'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { LoaderFunctionArgs } from 'react-router-dom'

export default class ContentUnsubscribeLoader extends RegisteredPlanBaseLoader {
  private static readonly ENROLLMENT_ID_PARAM = 'id'

  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }

  async loader({ params }: LoaderFunctionArgs) {
    const id = params[ContentUnsubscribeLoader.ENROLLMENT_ID_PARAM]
    if (id === undefined) return undefined

    return this.defer({
      data: super.importRemoteModule('makeRemoteContentUnsubscribe').then(async makeRemote => {
        const remote = makeRemote(this.queryClient) as ContentUnsubscribe
        return remote.getUnsubscribeData(id)
      })
    })
  }
}
